import { render, staticRenderFns } from "./AppConfigNewExtraction.vue?vue&type=template&id=242185fc&scoped=true&"
import script from "./AppConfigNewExtraction.vue?vue&type=script&lang=js&"
export * from "./AppConfigNewExtraction.vue?vue&type=script&lang=js&"
import style0 from "./AppConfigNewExtraction.vue?vue&type=style&index=0&id=242185fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242185fc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('242185fc')) {
      api.createRecord('242185fc', component.options)
    } else {
      api.reload('242185fc', component.options)
    }
    module.hot.accept("./AppConfigNewExtraction.vue?vue&type=template&id=242185fc&scoped=true&", function () {
      api.rerender('242185fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/modal/AppConfigNewExtraction.vue"
export default component.exports